import React from 'react' ;
import "./infoBox.css"
import {Card, CardContent, Typography} from "@material-ui/core" ;

function InfoBox({title, cases, isRed, isBlue, active, total, ...props}) {
    return (
<Card onClick={props.onClick} className={`infoBox ${active && "infoBox--selected"} ${ isRed && "infoBox--red"} ${ isBlue && "infoBox--blue" }`}>
  <CardContent>
     {/* Title */}
<Typography className="infoBox__title" color="textSecondary"> 
     {title}</Typography>

     {/* {number of cases} */}
   <h2 className={`infoBox__cases ${!isRed && "infoBox__cases--green"} ${isBlue && "infoBox__cases--blue" }`}>{cases}</h2>
             
     {/* {total} */}
   <Typography className="infoBox__total" color="textSecondary">
     {total} Total
    </Typography>

     </CardContent>
     </Card>
    )
}

export default InfoBox ;

// "infoBox" && ((active && "infoBox--selected")&&(isRed && "infoBox--red"))